import moment from 'moment';

export const getCurrentDateWithTimezone = () => moment.utc().utcOffset(-3 * 60);

export const getLastDayOfMonth = (date) => {
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  return lastDay.getDate();
};

export const getLastDayOfCurrentMonth = () => getLastDayOfMonth(new Date());

export const createDateDisabler =
  ({ minDate, maxDate, unit = 'day' } = {}) =>
  (currentDate) => {
    if (!currentDate) return false;
    if (minDate && currentDate.isBefore(minDate, unit)) return true;
    if (maxDate && currentDate.isAfter(maxDate, unit)) return true;
    return false;
  };

export const createRollingYearWindowDisabler = ({ startYear = 2000, yearsAhead = 2, unit = 'day' } = {}) => {
  const minDate = moment(`${startYear}-01-01`).startOf('day');
  const maxDate = moment().add(yearsAhead, 'years').endOf('year');

  return createDateDisabler({ minDate, maxDate, unit });
};

const DEFAULT_LOCALE = 'pt-BR';

export const formatDate = (dateInput) => {
  if (!dateInput) {
    return '';
  }
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  return date.toLocaleDateString(DEFAULT_LOCALE);
};
